// I18N
import { createI18n } from "vue-i18n";
import english from '@/lang/en';

const numberFormats = {
  'en-US': {
    currency: {
      style: 'currency', currency: 'USD', currencyDisplay: 'symbol'
    },
    decimal: {
      style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
    },
    percent: {
      style: 'percent', useGrouping: false
    }
  },
  'en-CA': {
    currency: {
      style: 'currency', currency: 'CAD', currencyDisplay: 'code'
    },
    decimal: {
      style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2
    },
    percent: {
      style: 'percent', useGrouping: false
    }
  }
}

const i18n = createI18n({
  legacy: false,
  locale: 'en-US',
  fallbackLocale: 'en-US',
  messages: {
    'en-US': english,
    'en-CA': english,
  },
  numberFormats,
});

export default i18n;
